import {
  IconMenu2,
  IconList,
  IconSchool,
  IconNote,
  IconMessage2,
  IconUsersGroup,
  IconLogin,
  IconLogout,
} from '@tabler/icons-react';

import { useObjectStore } from "../zustand/objects";
import { useAccountStore } from "../zustand/account"; 
import { ActionIcon, Menu } from '@mantine/core';
import StoryboardToolbarIcon from "./StoryboardToolbarIcon";
import EditorToolbarIcon from "./EditorToolbarIcon";
import { CHROME_TOOLBAR_ICON_GLYPH } from "../utils/editorChromeTheme";

const MenuButton = ({ pageName, iconColour, framed = false }) => {

 const { wipeProjectState, unloadObjects } = useObjectStore();
 const { logUserOut, isAuthUser } = useAccountStore();

 
  async function logout() {
    logUserOut() 
  }
 
const handleLogoutClick = () => {
  logout().then(() => window.location.replace('https://mbxr.io/login'))

}

  const handleProjectClick = () => {
    wipeProjectState()
    unloadObjects()
  }

  return (
    <>
      <Menu
        style={{ zIndex: 50000 }}
      >
        <Menu.Target>
          {framed ? (
            <StoryboardToolbarIcon label="Main menu" tooltip={false}>
              <IconMenu2 size={20} />
            </StoryboardToolbarIcon>
          ) : (
            <EditorToolbarIcon iconColour={iconColour}>
              <IconMenu2 size={CHROME_TOOLBAR_ICON_GLYPH} />
            </EditorToolbarIcon>
          )}
        </Menu.Target>

        <Menu.Dropdown>

          <Menu.Label>
            Resources
          </Menu.Label>
          {(pageName !== 'projects') && <Menu.Item onClick={handleProjectClick} component="a" href="/projects" leftSection={<IconList size={18} />}>
            Projects
          </Menu.Item>}
          <Menu.Item component="a" target="_blank" rel="noreferrer" href="https://www.matchboxxr.com/how-to" leftSection={<IconSchool size={18} />}>
              Guides
          </Menu.Item>
          <Menu.Item component="a" target="_blank" rel="noreferrer" href="/templates" leftSection={<IconNote size={18} />}>
            Template documents
          </Menu.Item>

          <Menu.Label>
            Account
          </Menu.Label>
          <Menu.Item component="a" target="_blank" rel="noreferrer" href="https://forms.gle/J4LkszzrjdimPoQX7" leftSection={<IconMessage2 size={18} />}>
            Give feedback
          </Menu.Item>
          {isAuthUser ? <Menu.Item component="a" href="/account" leftSection={<IconUsersGroup size={18} />}>
              Account Settings
            </Menu.Item> : <Menu.Item component="a" href="/login" leftSection={<IconLogin size={18} />}>
              Login
            </Menu.Item>}
          {isAuthUser && <Menu.Item onClick={handleLogoutClick} leftSection={<IconLogout size={18} />}>
            Logout</Menu.Item>}

        </Menu.Dropdown>
      </Menu>

  </>  
  );
};

export default MenuButton;